module.exports = __webpack_public_path__ + "static/media/4c40dc96.jpg";